import moment from 'moment'
import getTimeDiff from './getTimeDiff'

/**
 * Create from now to date with setInterval
 *
 * @param {string} datetime - ending date, will be parsed with momentjs
 * @callback callback
 * @param {string} time
 * @param {number} duration - timer timeout update
 *
 * @returns {NodeJS.Timeout}
 */
export default function getTimerFromNowToDate(datetime, callback, duration = 1000) {
  if (process.server) return

  let timerId
  let canceled
  let to = moment(datetime)

  const tickFn = () => {
    if (canceled) {
      clearTimeout(timerId)
      return
    }
    
    const time = moment().diff(moment(to))// getTimeDiff(to, moment(), true)

    timerId = setTimeout(tickFn, duration)

    if (typeof callback === 'function') {
      const params = callback(time, timerId)

      params && params.to && (to = moment(params.to))
      params && params.canceled && (canceled = params.canceled)
    }
  }

  tickFn()
  timerId = setTimeout(tickFn, duration)

  return timerId
}
